class LazerModalDialog extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;

    // Get elements
    this.overlay = this.querySelector('.modal-overlay');
    this.container = this.querySelector('.modal-container');
    this.closeButton = this.querySelector('.modal-close');

    if (!this.overlay || !this.container) {
      console.error('Required modal elements not found');
      return;
    }

    // Bind methods
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);

    // Add event listeners
    this.closeButton?.addEventListener('click', this.close);
    this.overlay.addEventListener('click', this.handleOverlayClick);
  }

  connectedCallback() {
    // Register click handler for any trigger elements
    document.querySelectorAll(`[data-modal-target="${this.id}"]`).forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleEscape);
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  handleOverlayClick(event) {
    // Only close if clicking directly on the overlay, not its children
    if (event.target === this.overlay) {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    }
  }

  open() {
    this.overlay.classList.remove('tw-hidden');
    this.container.classList.remove('tw-hidden');

    // Add backdrop blur
    this.overlay.classList.add('tw-backdrop-blur-sm');

    // Trigger reflow
    this.overlay.offsetHeight;

    this.overlay.classList.remove('tw-opacity-0');
    this.container.classList.remove('tw-opacity-0', 'tw-scale-95');
    this.container.classList.add('tw-scale-100');

    document.addEventListener('keydown', this.handleEscape);
    document.body.classList.add('tw-overflow-hidden');

    this.isOpen = true;
  }

  close() {
    this.overlay.classList.add('tw-opacity-0');
    this.container.classList.add('tw-opacity-0', 'tw-scale-95');
    this.container.classList.remove('tw-scale-100');

    setTimeout(() => {
      this.overlay.classList.add('tw-hidden');
      this.container.classList.add('tw-hidden');
      document.body.classList.remove('tw-overflow-hidden');
    }, 300);

    document.removeEventListener('keydown', this.handleEscape);

    this.isOpen = false;
  }
}

customElements.define('lazer-dialog', LazerModalDialog);
